module.exports = __webpack_public_path__ + "img/電気回路_3_6_3.0e9bc577.png";